import {initialShiftDraftsState, IShiftDraftsState} from '@app/core/store/state/shift-drafts.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {EShiftDraftsActions, ShiftDraftsActions} from '@app/core/store/actions/shift-drafts.actions';

export const shiftDraftsReducers = (
	state = initialShiftDraftsState,
	action: ShiftDraftsActions | ErrorActions,
): IShiftDraftsState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
				isReleasingDraft: false,
			};
		}
		case EShiftDraftsActions.GetShiftDrafts: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EShiftDraftsActions.GetShiftDraftsSuccess: {
			return {
				...state,
				isLoading: false,
				shiftDrafts: action.shiftDrafts.filter(shiftDraft => !shiftDraft.released)
			};
		}
		case EShiftDraftsActions.SetSelectedShiftDraft: {
			return {
				...state,
				selectedShiftDraft: action.shiftDraft
			};
		}
		case EShiftDraftsActions.CreateShiftDraftSuccess: {
			return {
				...state,
				shiftDrafts: [action.shiftDraft, ...state.shiftDrafts]
			};
		}
		case EShiftDraftsActions.DeleteShiftDraftSuccess: {
			return {
				...state,
				shiftDrafts: state.shiftDrafts.filter(shiftDraft => shiftDraft.id !== action.shiftDraft.id)
			};
		}
		case EShiftDraftsActions.ReleaseShiftDraft: {
			return {
				...state,
				isLoading: true,
				isReleasingDraft: true,
			};
		}
		case EShiftDraftsActions.SetIsReleasingDraft: {
			return {
				...state,
				isReleasingDraft: action.isReleasingDraft,
			};
		}
		case EShiftDraftsActions.ReleaseShiftDraftSuccess: {
			return {
				...state,
				isLoading: false,
				shiftDrafts: state.shiftDrafts.filter(shiftDraft => {
					return action.shiftDraft.id !== shiftDraft.id;
				})
			};
		}
		default:
			return state;
	}
};
